var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// istanbul ignore next
var isObject = function (obj) {
    if (typeof obj === 'object' && obj !== null) {
        if (typeof Object.getPrototypeOf === 'function') {
            var prototype = Object.getPrototypeOf(obj);
            return prototype === Object.prototype || prototype === null;
        }
        return Object.prototype.toString.call(obj) === '[object Object]';
    }
    return false;
};
export var deepMerge = function () {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    return objects.reduce(function (result, current) {
        if (Array.isArray(current)) {
            throw new TypeError('Arguments provided to deepMerge must be objects, not arrays.');
        }
        Object.keys(current).forEach(function (key) {
            if (['__proto__', 'constructor', 'prototype'].includes(key)) {
                return;
            }
            if (Array.isArray(result[key]) && Array.isArray(current[key])) {
                result[key] = deepMerge.options.mergeArrays
                    ? Array.from(new Set(result[key].concat(current[key])))
                    : current[key];
            }
            else if (isObject(result[key]) && isObject(current[key])) {
                result[key] = deepMerge(result[key], current[key]);
            }
            else {
                result[key] = current[key];
            }
        });
        return result;
    }, {});
};
var defaultOptions = {
    mergeArrays: true,
};
deepMerge.options = defaultOptions;
deepMerge.withOptions = function (options) {
    var objects = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        objects[_i - 1] = arguments[_i];
    }
    deepMerge.options = __assign({ mergeArrays: true }, options);
    var result = deepMerge.apply(void 0, objects);
    deepMerge.options = defaultOptions;
    return result;
};
export default deepMerge;
